import axios from "axios";

import { GROWTH_INSURANCE_API } from "@modules/common/constants";
/*
 * Upload steady labs documents
 * */

export type UploadLabsResponse = {
  data: {
    url: string;
    contentType: string;
    title: string;
  }[];
};

export const uploadSteadyLabs = async (
  userId: string,
  accessToken: string,
  formData: FormData
): Promise<UploadLabsResponse> => {
  return (
    await axios.post<UploadLabsResponse>(
      `${GROWTH_INSURANCE_API}/v1/patient/${userId}/upload_labs/`,
      formData,
      {
        headers: {
          Authorization: `bearer ${accessToken}`,
        },
      }
    )
  ).data;
};
